import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate, title }) => {
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      // Clone targetDate to avoid mutating the prop, though we set year below
      let target = new Date(targetDate);
      target.setFullYear(now.getFullYear());

      // If the date has passed this year, set to next year
      if (now > target) {
        target.setFullYear(now.getFullYear() + 1);
      }

      const difference = target - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="countdown-timer">
      <h2 className="christmass-header">{title}</h2>
      <div className="timer-display">
        <div className="timer-unit">
          <span className="number">{timeLeft.days || 0}</span>
          <span className="label">днів</span>
        </div>
        <div className="timer-unit">
          <span className="number">{timeLeft.hours || 0}</span>
          <span className="label">годин</span>
        </div>
        <div className="timer-unit">
          <span className="number">{timeLeft.minutes || 0}</span>
          <span className="label">хвилин</span>
        </div>
        <div className="timer-unit">
          <span className="number">{timeLeft.seconds || 0}</span>
          <span className="label">секунд</span>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;